export type EmployeeApplicationStatusType = 'Draft' | 'Published' | 'Deactivated';
export type EmployeeApplicationDataSourceType = 'SIS' | 'IDM' | 'DVS';
export type EmployeeApplicationDataSourceResultType = 'List' | 'Dictionary';
export type EmployeeApplicationOrderProcessType = 'None' | 'DVS';
export type EmployeeApplicationFormFieldType = 'Date' | 'Integer' | 'Select' | 'Autocomplete' | 'Text' | 'Multiline' | 'Money';

export class EmployeeApplicationConfig {
    Id: number;
    Code: string;
    Status: EmployeeApplicationStatusType;
    Version: number;
    NameLV: string;
    NameEN: string;
    Group: string;
    GroupId: string;
    OrderProcess: EmployeeApplicationOrderProcessType;
    DataSources: EmployeeApplicationDataSource[] = [];
    FormFields: EmployeeApplicationFormField[] = [];
    FormFileFields: EmployeeApplicationFormFileField[] = [];
    Template: { Id: number, FileNameLV: string, FileNameEN: string };
    OrderTemplate: { Id: number, FileNameLV: string, FileNameEN: string };
}

export class EmployeeApplicationConfigSaveModel {
    Id?: number;
    Code: string;
    NameLV: string;
    NameEN: string;
    GroupId: string;
    OrderProcess: EmployeeApplicationOrderProcessType;
    DataSources: EmployeeApplicationDataSource[] = [];
    FormFields: EmployeeApplicationFormField[] = [];
    FormFileFields: EmployeeApplicationFormFileField[] = [];
    Template: {
        Id?: number,
        LV?: { Base64: string },
        EN?: { Base64: string }
    };
    OrderTemplate: {
        Id?: number,
        LV?: { Base64: string },
        EN?: { Base64: string }
    };
}

export interface IEmployeeApplicationConfigListItem {
    Id: number;
    Code: string;
    Status: EmployeeApplicationStatusType;
    Version: number;
    Name: string;
}

export class EmployeeApplicationDataSource {
    Name: string;
    Database: EmployeeApplicationDataSourceType;
    Procedure: string;
    ResultType: EmployeeApplicationDataSourceResultType;
}

export class EmployeeApplicationFormField {
    Name: string;
    NameLV: string;
    NameEN: string;
    Type: EmployeeApplicationFormFieldType;
    Row: string;
    Size: number;
    Required: boolean;
    Editable: boolean;
    Source: string;
}

export class EmployeeApplicationFormFileField {
    Name: string;
    NameLV: string;
    NameEN: string;
    Row: string;
    Extensions: string;
    MaxSize: number;
    MaxFileCount: number;
    Required: boolean;
}
